/**
 * Check if authentication is enabled via environment variable
 * Defaults to false (off) if not set
 * 
 * To enable authentication, set REACT_APP_ENABLE_AUTH to one of:
 * - 'true'
 * - '1'
 */
export const isAuthEnabled = (): boolean => {
  const authEnabled = process.env.REACT_APP_ENABLE_AUTH;
  return authEnabled === 'true' || authEnabled === '1';
};

